import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@components/primitives/Button';
import { FeatureCard } from '@components/ui/cards/FeatureCard';
import { useUser } from '@features/user';
import { useEventTracking } from '@services/statsig';
import { publicAsset } from '@utils/publicAsset';

import { NotesLoader } from '../../../../loaders/DashboardLoader';
import NoteIcon from '../../assets/ai-note.svg?react';

import { CardImg } from './shared/CardImg';

export const NotesCard = () => {
  const navigate = useNavigate();
  const { dashboard } = useEventTracking();
  const { userState } = useUser();
  const [firstNoteId, setFirstNoteId] = useState<string | null>(null);

  // Fetch the first note when component mounts
  useEffect(() => {
    const loadFirstNote = async () => {
      if (userState?.user_id) {
        try {
          const { notes } = await NotesLoader('all', 1); // Get just the first note
          if (notes.length > 0) {
            setFirstNoteId(notes[0].note_id);
          }
        } catch (error) {
          console.error('Failed to load notes:', error);
        }
      }
    };

    void loadFirstNote();
  }, [userState?.user_id]);

  const handleReviewNotes = () => {
    dashboard.actionClicked({
      action_type: 'review_notes',
      source: 'dashboard_v2_card',
    });
    // Navigate to the first note if available, otherwise to notes list
    if (firstNoteId) {
      navigate(`/note/${firstNoteId}`);
    } else {
      navigate('/notes');
    }
  };

  return (
    <FeatureCard
      icon={<NoteIcon width={20} height={20} fill="currentColor" />}
      title="Review & Sign Notes"
      fullHeight
      onClick={handleReviewNotes}
      action={<Button>Edit a Sample Note</Button>}
    >
      <CardImg src={publicAsset('/dashboard/home-tile_review-notes.png')} alt="Review & Sign Notes" />
    </FeatureCard>
  );
};
